class Tarapprendre {
  constructor() {
    this.$container = $('body')
    this.$target = this.$container.find('.tarapprendre-block')
    this.$form = this.$target.find('.tarapprendre-form')
    this.$inputField = this.$form.find('input[type="radio"]')
    this.label = this.$form.data('label')
    this.scopeAnswer = {
      good: 'good',
      wrong: 'wrong',
    }
    this.ajaxMethod = {
      putAction: 'query_quiz',
    }
    if (this.$target.length) {
      this.initialize()
    }
  }

  initialize() {
    this.$inputField.on('change', () => {
      const data = {
        action: this.ajaxMethod.putAction,
        // eslint-disable-next-line no-undef
        security: ajax_object.ajax_nonce,
        post_id: this.$form.data('post'),
      }
      this.ajaxRequest(data)
    })
  }

  ajaxRequest(data) {
    $.ajax({
      // eslint-disable-next-line no-undef
      url: ajax_object.ajax_url,
      method: 'POST',
      data: data,
    }).done((response) => {
      const data = JSON.parse(response)
      data.forEach(el => {
        const $field = this.$form.find(`#${el.field_id}`)
        $field.attr('disabled', 'disabled')
        const $container = $field.parents('.answer')
        if (el.is_correct === true) {
          $container.addClass(this.scopeAnswer.good)
          $container.find('.answer_label').html(this.label)
        } else {
          $container.addClass(this.scopeAnswer.wrong)
        }
      })
    })
  }
}

export default Tarapprendre;



// WEBPACK FOOTER //
// ./scripts/components/Tarapprendre.js